module.exports = __webpack_public_path__ + "static/h1Yes-a04e69de9210132f8d2b3d9c1d15680f.png";